import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ number, label, dark = false }) => (
    <div className="flex items-center gap-4">
        <span className="font-mono-tl text-xs tracking-[0.25em] text-tl-orange">
            {number}
        </span>
        <span className="h-px w-10 bg-tl-orange/60" />
        <span
            className={`font-mono-tl text-xs uppercase tracking-[0.3em] ${
                dark ? "text-tl-mutedDark" : "text-tl-mutedLight"
            }`}
        >
            {label}
        </span>
    </div>
);
